<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="row">
  @if (dialogMode === 'edit' || dialogMode === 'verify') {
    <div class="col-12">
      <form class="row" (ngSubmit)="onSubmit(f)" #f="ngForm">
        <div class="col-12 mt-4 font-size-smaller1 ml-3">
          <div class="row">
            <div class="col-12">
              <p class="mb-1">
                {{ 'user-self-service.tax.change-joint-fsa.personal-data.hint' | transloco }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-4">{{ 'user-self-service.tax.change-joint-fsa.personal-data.name' | transloco }}</div>
            <div class="col-8">
              {{ customerBaseData?.firstName + ' ' + customerBaseData?.lastName }}
            </div>
            <div class="col-4">{{ 'user-self-service.tax.change-joint-fsa.personal-data.street' | transloco }}</div>
            <div class="col-8">
              {{ customerBaseData?.street1 + ' ' + customerBaseData?.streetNr }}
            </div>
            <div class="col-4">{{ 'user-self-service.tax.change-joint-fsa.personal-data.city' | transloco }}</div>
            <div class="col-8">
              {{ customerBaseData?.postalCode + ' ' + customerBaseData?.city }}
            </div>
            <div class="col-4">{{ 'user-self-service.tax.change-joint-fsa.personal-data.tin' | transloco }}</div>
            <div class="col-8">{{ customerBaseData?.taxId }}</div>
          </div>
        </div>
        <div class="col-12 mt-5">
          <div class="row">
            <div class="col-12">
              <p class="font-medium">{{ 'user-self-service.tax.change-joint-fsa.partner-data.hint' | transloco }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  id="acknowledgePartnerInformed"
                  name="acknowledgePartnerInformed"
                  class="custom-control-input"
                  [(ngModel)]="jointFsaData.ackPartnerInformed"
                  (input)="inputValueChanged()"
                  required
                />
                <label class="custom-control-label" for="acknowledgePartnerInformed">
                  {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-partner-informed' | transloco }}
                </label>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12 col-sm-6">
              <div
                class="input-group-material select-dropdown margin-top-15"
                [class.input-group-material--error]="anredeSelectVar.invalid && anredeSelectVar.touched"
              >
                <select
                  [(ngModel)]="jointFsaData.salutation"
                  name="anredeSelect"
                  id="anredeSelect"
                  #anredeSelectVar="ngModel"
                  [class.empty]="!anredeSelectVar.value"
                  required
                  data-zid="salutation"
                  (input)="inputValueChanged()"
                  autocomplete="off"
                >
                  <option ngValue=""></option>
                  <option ngValue="Herr">{{ 'user-self-service.tax.change-joint-fsa.partner-data.salutation-opt-mr' | transloco }}</option>
                  <option ngValue="Frau">{{ 'user-self-service.tax.change-joint-fsa.partner-data.salutation-opt-mrs' | transloco }}</option>
                </select>
                <label for="anredeSelect" [innerHTML]="'user-self-service.tax.change-joint-fsa.partner-data.label-salutation' | transloco">
                  -
                </label>

                @if (anredeSelectVar.valid || !anredeSelectVar.value) {
                  <div class="input-group-material-message">&nbsp;</div>
                }
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="input-group-material select-dropdown margin-top-15">
                <select
                  [(ngModel)]="jointFsaData.title"
                  name="titelSelect"
                  id="titelSelect"
                  #titelSelectVar="ngModel"
                  [class.empty]="!titelSelectVar.value"
                  data-zid="title"
                  (input)="inputValueChanged()"
                  autocomplete="off"
                >
                  <option ngValue=""></option>
                  <option ngValue="Prof.">{{ 'user-self-service.tax.change-joint-fsa.partner-data.title-opt-prof' | transloco }}</option>
                  <option ngValue="Prof. Dr.">
                    {{ 'user-self-service.tax.change-joint-fsa.partner-data.title-opt-profdr' | transloco }}
                  </option>
                  <option ngValue="Dr.">{{ 'user-self-service.tax.change-joint-fsa.partner-data.title-opt-dr' | transloco }}</option>
                  <option ngValue="Dr. Dr.">{{ 'user-self-service.tax.change-joint-fsa.partner-data.title-opt-drdr' | transloco }}</option>
                </select>
                <label for="titelSelect">{{ 'user-self-service.tax.change-joint-fsa.partner-data.label-title' | transloco }}</label>
                @if (titelSelectVar.valid) {
                  <div class="input-group-material-message">&nbsp;</div>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6">
              <div
                class="input-group-material margin-top-15"
                [class.input-group-material--error]="!vornameInputVar.value && vornameInputVar.touched"
              >
                <input
                  type="text"
                  required
                  [(ngModel)]="jointFsaData.firstName"
                  name="vornameInput"
                  id="vornameInput"
                  pattern="^(?!([0-9])).+$"
                  #vornameInputVar="ngModel"
                  [class.empty]="!vornameInputVar.value"
                  data-zid="firstName"
                  (input)="inputValueChanged()"
                  autocomplete="off"
                />
                <div class="input-group-material-icon-state"></div>
                <label for="vornameInput" [innerHTML]="'user-self-service.tax.change-joint-fsa.partner-data.label-first-name' | transloco">
                  -
                </label>
                @if (!vornameInputVar.value || vornameInputVar.valid) {
                  <div class="input-group-material-message">
                    {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-first-name-value' | transloco }}
                  </div>
                }
                @if (vornameInputVar.errors && vornameInputVar.errors['pattern']) {
                  <div class="input-group-material-message">
                    {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-first-name-error' | transloco }}
                  </div>
                }
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div
                class="input-group-material margin-top-15"
                [class.input-group-material--error]="!nachnameInputVar.value && nachnameInputVar.touched"
              >
                <input
                  type="text"
                  required
                  [(ngModel)]="jointFsaData.lastName"
                  name="nachnameInput"
                  id="nachnameInput"
                  pattern="^(?!([0-9])).+$"
                  #nachnameInputVar="ngModel"
                  [class.empty]="!nachnameInputVar.value"
                  data-zid="lastName"
                  (input)="inputValueChanged()"
                  autocomplete="off"
                />
                <span class="input-group-material-icon-state"></span>
                <label for="nachnameInput" [innerHTML]="'user-self-service.tax.change-joint-fsa.partner-data.label-last-name' | transloco">
                  -
                </label>
                @if (!nachnameInputVar.value || nachnameInputVar.valid) {
                  <div class="input-group-material-message">
                    {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-last-name-value' | transloco }}
                  </div>
                }
                @if (nachnameInputVar.errors && nachnameInputVar.errors['pattern']) {
                  <div class="input-group-material-message">
                    {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-last-name-error' | transloco }}
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6">
              <div
                class="input-group-material margin-top-15"
                [class.input-group-material--error]="!geburtsdatumInputVar.value && geburtsdatumInputVar.touched"
              >
                <input
                  type="text"
                  [class.empty]="!geburtsdatumInputVar.value"
                  [(ngModel)]="jointFsaData.birthDate"
                  name="geburtsdatumInput"
                  id="geburtsdatumInput"
                  #geburtsdatumInputVar="ngModel"
                  ngbDatepicker
                  #d="ngbDatepicker"
                  (dblclick)="d.open()"
                  webAppServicesGermanNgbDateValidator
                  required
                  data-zid="birthDate"
                  (input)="inputValueChanged()"
                  autocomplete="off"
                  [maxDate]="birthDateMax"
                />
                <span class="input-group-material-icon-state"></span>
                <label
                  for="geburtsdatumInput"
                  [innerHTML]="'user-self-service.tax.change-joint-fsa.partner-data.label-dateofbirth' | transloco"
                >
                  -
                </label>
                @if (geburtsdatumInputVar.valid) {
                  <div class="input-group-material-message">&nbsp;</div>
                }
                @if (
                  geburtsdatumInputVar.hasError('ngbDate') &&
                  geburtsdatumInputVar.getError('ngbDate').hasOwnProperty('maxDate') &&
                  !geburtsdatumInputVar.hasError('noValidGermanDate')
                ) {
                  <div class="input-group-material-message">
                    {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-dateofbirth-error-18' | transloco }}
                  </div>
                }
                @if (
                  (geburtsdatumInputVar.hasError('ngbDate') &&
                    (geburtsdatumInputVar.getError('ngbDate').hasOwnProperty('requiredBefore') ||
                      geburtsdatumInputVar.getError('ngbDate').hasOwnProperty('invalid'))) ||
                  geburtsdatumInputVar.hasError('noValidGermanDate')
                ) {
                  <div class="input-group-material-message">
                    {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-dateofbirth-error-invalid' | transloco }}
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 mb-2">
              <div
                class="input-group-material margin-top-15"
                [class.input-group-material--error]="
                  (!steueridInputVar.value && steueridInputVar.touched) || (steueridInputVar.value && steueridInputVar.errors)
                "
              >
                <input
                  type="text"
                  required
                  [(ngModel)]="jointFsaData.taxId"
                  name="steueridInput"
                  id="steueridInput"
                  formValidatorsTinValidator
                  [countryCode]="'DE'"
                  [tinValidatorForbiddenTin]="customerBaseData.taxId"
                  #steueridInputVar="ngModel"
                  [class.empty]="!steueridInputVar.value"
                  data-zid="tin"
                  autocomplete="off"
                />
                <div class="input-group-material-icon-state"></div>
                <label for="steueridInput" [innerHTML]="'user-self-service.tax.change-joint-fsa.partner-data.label-tin' | transloco">
                  -
                </label>
                @if (steueridInputVar?.valid || steueridInputVar.hasError('required')) {
                  <div class="input-group-material-message">
                    {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-tin-value' | transloco }}
                  </div>
                }
                @if (steueridInputVar.errors && steueridInputVar.errors['invalidCountryTin']) {
                  <div class="input-group-material-message">
                    {{ steueridInputVar.getError('invalidCountryTin') }}
                  </div>
                }
                @if (steueridInputVar.hasError('forbiddenTin')) {
                  <div class="input-group-material-message">
                    {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-tin-error' | transloco }}
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="custom-control custom-checkbox">
                <input
                  #sameAddressInputVar="ngModel"
                  type="checkbox"
                  id="sameAddress"
                  name="sameAddress"
                  class="custom-control-input"
                  [(ngModel)]="jointFsaData.sameAddress"
                  (input)="inputValueChanged()"
                />
                <label class="custom-control-label" for="sameAddress">{{
                  'user-self-service.tax.change-joint-fsa.partner-data.label-same-address' | transloco
                }}</label>
              </div>
            </div>
          </div>
          @if (!sameAddressInputVar.value) {
            <div class="row mt-4">
              <div class="col-12">
                <p class="font-medium">{{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-address' | transloco }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6">
                <div
                  class="input-group-material margin-top-15"
                  [class.input-group-material--error]="!streetInputVar.value && streetInputVar.touched"
                >
                  <input
                    type="text"
                    [(ngModel)]="jointFsaData.street"
                    name="streetInput"
                    id="streetInput"
                    required
                    pattern="^(?!([0-9])).+$"
                    #streetInputVar="ngModel"
                    [class.empty]="!streetInputVar.value"
                    data-zid="street"
                    (input)="inputValueChanged()"
                    autocomplete="off"
                  />
                  <span class="input-group-material-icon-state"></span>
                  <label for="streetInput" [innerHTML]="'user-self-service.tax.change-joint-fsa.partner-data.label-street' | transloco">
                    -
                  </label>
                  @if (!streetInputVar.value || streetInputVar.valid) {
                    <div class="input-group-material-message">
                      {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-street-value' | transloco }}
                    </div>
                  }
                  @if (streetInputVar.errors && streetInputVar.errors['pattern']) {
                    <div class="input-group-material-message">
                      {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-street-error' | transloco }}
                    </div>
                  }
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div
                  class="input-group-material margin-top-15"
                  [class.input-group-material--error]="!hausnummerInputVar.value && hausnummerInputVar.touched"
                >
                  <input
                    type="text"
                    required
                    [(ngModel)]="jointFsaData.streetNr"
                    name="hausnummerInput"
                    id="hausnummerInput"
                    pattern="^[0-9]+.*$"
                    #hausnummerInputVar="ngModel"
                    [class.empty]="!hausnummerInputVar.value"
                    data-zid="streetNumber"
                    (input)="inputValueChanged()"
                    autocomplete="off"
                  />
                  <div class="input-group-material-icon-state"></div>
                  <label
                    for="hausnummerInput"
                    [innerHTML]="'user-self-service.tax.change-joint-fsa.partner-data.label-house-number' | transloco"
                  >
                    -
                  </label>
                  @if (!hausnummerInputVar.value || hausnummerInputVar.valid) {
                    <div class="input-group-material-message">
                      {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-house-number-value' | transloco }}
                    </div>
                  }
                  @if (hausnummerInputVar.errors && hausnummerInputVar.errors['pattern']) {
                    <div class="input-group-material-message">
                      {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-house-number-error' | transloco }}
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="input-group-material margin-top-15">
                  <input
                    type="text"
                    [(ngModel)]="jointFsaData.additionalAddress"
                    name="adresszusatzInput"
                    id="adresszusatzInput"
                    #adresszusatzInputVar="ngModel"
                    [class.empty]="!adresszusatzInputVar.value"
                    autocomplete="off"
                  />
                  <div class="input-group-material-icon-state"></div>
                  <label for="adresszusatzInput">{{
                    'user-self-service.tax.change-joint-fsa.partner-data.label-address-supplement' | transloco
                  }}</label>
                  <div class="input-group-material-message">
                    {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-address-supplement-value' | transloco }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6">
                <div
                  class="input-group-material margin-top-15"
                  [class.input-group-material--error]="!plzInputVar.value && plzInputVar.touched"
                >
                  <input
                    type="text"
                    required
                    [(ngModel)]="jointFsaData.postalCode"
                    name="plzInput"
                    id="plzInput"
                    [pattern]="postCodeValidationPattern()"
                    #plzInputVar="ngModel"
                    [class.empty]="!plzInputVar.value"
                    data-zid="zip"
                    (input)="inputValueChanged()"
                    autocomplete="off"
                  />
                  <div class="input-group-material-icon-state"></div>
                  <label for="plzInput" [innerHTML]="'user-self-service.tax.change-joint-fsa.partner-data.label-postal-code' | transloco">
                    -
                  </label>
                  @if (!plzInputVar.value || plzInputVar.valid) {
                    <div class="input-group-material-message">
                      {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-postal-code-value' | transloco }}
                    </div>
                  }
                  @if (plzInputVar.errors && plzInputVar.errors['pattern']) {
                    <div class="input-group-material-message">
                      {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-postal-code-error' | transloco }}
                    </div>
                  }
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div
                  class="input-group-material margin-top-15"
                  [class.input-group-material--error]="!cityInputVar.value && cityInputVar.touched"
                >
                  <input
                    type="text"
                    [(ngModel)]="jointFsaData.city"
                    name="cityInput"
                    id="cityInput"
                    required
                    pattern="^(?!([0-9])).+$"
                    #cityInputVar="ngModel"
                    [class.empty]="!cityInputVar.value"
                    data-zid="city"
                    (input)="inputValueChanged()"
                    autocomplete="off"
                  />
                  <span class="input-group-material-icon-state"></span>
                  <label for="cityInput" [innerHTML]="'user-self-service.tax.change-joint-fsa.partner-data.label-city' | transloco">
                    -
                  </label>
                  @if (!cityInputVar.value || cityInputVar.valid) {
                    <div class="input-group-material-message">
                      {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-city-value' | transloco }}
                    </div>
                  }
                  @if (cityInputVar.errors && cityInputVar.errors['pattern']) {
                    <div class="input-group-material-message">
                      {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-city-error' | transloco }}
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6">
                <div
                  class="input-group-material select-dropdown margin-top-15"
                  [class.input-group-material--error]="!landSelectVar.value && landSelectVar.touched"
                >
                  <select
                    [(ngModel)]="jointFsaData.country"
                    name="landSelect"
                    id="landSelect"
                    #landSelectVar="ngModel"
                    [class.empty]="!landSelectVar.value"
                    required
                    value="DE"
                    data-zid="country"
                    (input)="inputValueChanged()"
                    autocomplete="off"
                  >
                    @for (cVal of countriesService.isoCodesSortedByDisplayName_NoUSA_NoHighRiskCountries; track $index) {
                      <option [value]="cVal">
                        {{ countriesService.allIsoCountriesEnum[cVal] }}
                      </option>
                    }
                  </select>
                  <label for="landSelect">{{ 'user-self-service.tax.change-joint-fsa.partner-data.label-country' | transloco }}</label>
                  @if (landSelectVar.valid) {
                    <div class="input-group-material-message">
                      {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-country-value' | transloco }}
                    </div>
                  }
                  @if (!landSelectVar.value) {
                    <div class="input-group-material-message">
                      {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-country-error' | transloco }}
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          <div class="row mt-4">
            <div class="col-12">
              <div class="font-medium">{{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-customer' | transloco }}</div>
              <div class="d-flex mt-2">
                <div class="custom-control custom-checkbox">
                  <input
                    #partnerIsCustomer="ngModel"
                    type="checkbox"
                    id="partnerIsCustomer"
                    name="partnerIsCustomer"
                    class="custom-control-input"
                    [(ngModel)]="jointFsaData.partnerIsCustomer"
                    (change)="partnerIsNotCustomer.reset(!partnerIsCustomer.value)"
                    (input)="inputValueChanged()"
                  />
                  <label class="custom-control-label pl-0 mr-3" for="partnerIsCustomer">{{
                    'user-self-service.tax.change-joint-fsa.partner-data.label-customer-yes' | transloco
                  }}</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input
                    #partnerIsNotCustomer="ngModel"
                    type="checkbox"
                    id="partnerIsNotCustomer"
                    name="partnerIsNotCustomer"
                    class="custom-control-input"
                    [(ngModel)]="jointFsaData.partnerIsNotCustomer"
                    (change)="partnerIsCustomer.reset(!partnerIsNotCustomer.value)"
                    (input)="inputValueChanged()"
                  />
                  <label class="custom-control-label pl-0" for="partnerIsNotCustomer">{{
                    'user-self-service.tax.change-joint-fsa.partner-data.label-customer-no' | transloco
                  }}</label>
                </div>
              </div>
            </div>
          </div>
          @if (jointFsaData.partnerIsCustomer) {
            <div class="row mt-2">
              <div class="col-12 col-sm-6">
                <div
                  class="input-group-material margin-top-15"
                  [class.input-group-material--error]="!pCustomerIdInputVar.value && pCustomerIdInputVar.touched"
                >
                  <input
                    type="text"
                    required
                    [(ngModel)]="jointFsaData.pCustomerId"
                    name="pCustomerId"
                    id="pCustomerId"
                    [pattern]="CUSTOMER_ID_PATTERN"
                    #pCustomerIdInputVar="ngModel"
                    [class.empty]="!pCustomerIdInputVar.value"
                    data-zid="pCustomerId"
                    (input)="inputValueChanged()"
                    autocomplete="off"
                  />
                  <span class="input-group-material-icon-state"></span>
                  <label
                    for="pCustomerId"
                    [innerHTML]="'user-self-service.tax.change-joint-fsa.partner-data.label-customer-id' | transloco"
                  >
                    -
                  </label>
                  @if (!pCustomerIdInputVar.value || pCustomerIdInputVar.valid) {
                    <div class="input-group-material-message">
                      {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-customer-id-value' | transloco }}
                    </div>
                  }
                  @if (pCustomerIdInputVar.errors && pCustomerIdInputVar.errors['pattern']) {
                    <div class="input-group-material-message">
                      {{ 'user-self-service.tax.change-joint-fsa.partner-data.hint-customer-id-error' | transloco }}
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @if (dialogMode === 'edit') {
          <div class="col-12 mt-4">
            <p class="font-medium">{{ 'user-self-service.tax.change-joint-fsa.label-fsa' | transloco }}</p>
          </div>
        }
        @if (dialogMode === 'edit') {
          <div class="col-12 col-sm-6">
            <div
              class="input-group-material Xinput-group-material--centered pb-2 margin-top-15"
              [class.input-group-material--error]="fsaAmountInputVar.invalid && fsaAmountInputVar.touched"
            >
              <web-components-number-input
                id="fsaAmount"
                [(ngModel)]="editData[ATTR_NEW_FSA_AMOUT]"
                name="fsaAmount"
                [zeroPositiveAndInputLowerThan]="2000"
                [minimumValue]="fsaMinValue(editData[ATTR_NEW_FSA_VALIDFROM])"
                required
                [label]="'user-self-service.tax.change-joint-fsa.label-amount' | transloco"
                #fsaAmountInputVar="ngModel"
                (input)="inputValueChanged()"
              />
              @if (fsaAmountInputVar.valid || (fsaAmountInputVar.hasError('required') && fsaAmountInputVar.errors['length'] === 1)) {
                <div class="input-group-material-message">&nbsp;</div>
              }
              @if (fsaAmountInputVar.hasError('inputLowerThan')) {
                <div class="input-group-material-message">
                  {{ 'user-self-service.tax.change-joint-fsa.hint-amount-error-lower' | transloco }}
                </div>
              }
              @if (fsaAmountInputVar.hasError('minimumValue')) {
                <div
                  class="input-group-material-message"
                  [innerHTML]="
                    'user-self-service.tax.change-joint-fsa.hint-amount-error-used-max'
                      | transloco: { fsaUsed: customerBaseData.fsaUsed | currency: 'EUR' : 'symbol' }
                  "
                ></div>
              }
              @if (fsaAmountInputVar.hasError('positiveNonNull')) {
                <div class="input-group-material-message">
                  {{ 'user-self-service.tax.change-joint-fsa.hint-amount-error-min-max' | transloco }}
                </div>
              }
            </div>
          </div>
        }
        @if (dialogMode === 'edit') {
          <div class="col-12 col-sm-6 mt-3 mt-sm-0">
            <div
              class="input-group-material margin-top-15"
              [class.input-group-material--error]="fsavalidfromInputVar.invalid && fsavalidfromInputVar.touched"
            >
              <input
                type="text"
                required
                [(ngModel)]="editData[ATTR_NEW_FSA_VALIDFROM]"
                name="fsavalidfromyear"
                id="fsavalidfromyear"
                #fsavalidfromInputVar="ngModel"
                [class.empty]="!fsavalidfromInputVar.value"
                pattern="\d{4}"
                formValidatorsYearInputValidator
                [minYear]="validFromMinYear"
                [maxYear]="validFromMaxYear"
                (input)="inputValueChanged()"
                autocomplete="off"
              />
              <span class="input-group-material-icon-state"></span>
              <label for="fsavalidfromyear" [innerHTML]="'user-self-service.tax.change-joint-fsa.label-valid-from' | transloco"> - </label>
              @if (fsavalidfromInputVar.valid || fsavalidfromInputVar.hasError('required')) {
                <div class="input-group-material-message">&nbsp;</div>
              }
              @if (fsavalidfromInputVar.hasError('minYear') || fsavalidfromInputVar.hasError('maxYear')) {
                <div class="input-group-material-message">
                  {{ 'user-self-service.tax.change-joint-fsa.valid-from' | transloco: { fromYear: validFromMinYear } }}
                </div>
              }
            </div>
          </div>
        }
        @if (dialogMode === 'edit') {
          <div class="col-12">
            <div class="custom-control custom-checkbox margin-bottom-15 Xmargin-top-15">
              <input
                #checkValidToInputVar="ngModel"
                type="checkbox"
                id="checkValidTo"
                name="checkValidTo"
                class="custom-control-input"
                [(ngModel)]="checkValidTo"
                (change)="checkValidToChanged()"
                (input)="inputValueChanged()"
                autocomplete="off"
              />
              <label class="custom-control-label" for="checkValidTo">
                {{ 'user-self-service.tax.change-joint-fsa.label-valid-to-infinity' | transloco }}
              </label>
            </div>
          </div>
        }
        @if (!checkValidTo && dialogMode === 'edit') {
          <div class="col-12 col-sm-6 Xmt-sm-4 mt-2">
            <div
              class="input-group-material"
              [class.input-group-material--error]="fsavalidtoInputVar.invalid && fsavalidtoInputVar.touched"
            >
              <input
                type="text"
                required
                [(ngModel)]="editData[ATTR_NEW_FSA_VALIDTO]"
                name="fsavalidtoyear"
                id="fsavalidtoyear"
                #fsavalidtoInputVar="ngModel"
                [class.empty]="!fsavalidtoInputVar.value"
                pattern="\d{4}"
                formValidatorsYearInputValidator
                [minYear]="editData[ATTR_NEW_FSA_VALIDFROM]"
                (input)="inputValueChanged()"
                autocomplete="off"
              />
              <span class="input-group-material-icon-state"></span>
              <label for="fsavalidtoyear" [innerHTML]="'user-self-service.tax.change-joint-fsa.label-valid-to' | transloco"> - </label>
              @if (fsavalidtoInputVar.valid || fsavalidtoInputVar.hasError('required')) {
                <div class="input-group-material-message">
                  {{ 'user-self-service.tax.change-joint-fsa.hint-valid-to-value' | transloco }}
                </div>
              }
              @if (fsavalidtoInputVar.hasError('minYear') || fsavalidtoInputVar.hasError('maxYear')) {
                <div class="input-group-material-message">
                  {{ 'user-self-service.tax.change-joint-fsa.hint-valid-to-error' | transloco }}
                </div>
              }
            </div>
          </div>
        }
        @if (checkValidTo) {
          <div class="col-6 d-none d-sm-block"></div>
        }
        @if (dialogMode === 'edit') {
          <div class="col-12 d-flex">
            @if (f.valid) {
              <web-design-system-button [isSubmit]="true" type="secondary" size="small" [href]="getPreviewPdfFileUrl()">
                {{ 'user-self-service.tax.change-joint-fsa.btn-preview' | transloco }}
              </web-design-system-button>
            }
            @if (!f.valid) {
              <web-design-system-button type="secondary" [disabled]="true" size="small">
                {{ 'user-self-service.tax.change-joint-fsa.btn-preview-disabled' | transloco }}
              </web-design-system-button>
            }
          </div>
        }
        @if (dialogMode === 'edit') {
          <div class="col-12">
            <div class="custom-control custom-checkbox margin-bottom-15 mt-2">
              <input type="checkbox" id="previewSeen" name="previewSeen" class="custom-control-input" [(ngModel)]="previewSeen" />
              <label
                class="custom-control-label"
                for="previewSeen"
                [innerHTML]="'user-self-service.tax.change-joint-fsa.label-preview-seen' | transloco"
              >
                -
              </label>
            </div>
          </div>
        }
        @if (dialogMode === 'edit') {
          <div class="col-12 d-flex flex-column margin-top-15 margin-bottom-15 justify-content-between">
            <span class="mb-3">{{ 'user-self-service.tax.change-joint-fsa.hint-authorization-required' | transloco }}</span>
            <div>
              <web-design-system-button size="small" [disabled]="!f.valid || !previewSeen" [isSubmit]="true">
                {{ 'user-self-service.tax.change-joint-fsa.btn-continue' | transloco }}
              </web-design-system-button>
            </div>
          </div>
        }
      </form>
      @if (dialogMode === 'verify') {
        <div class="row">
          <div class="col-12">
            <p class="mt-3 border-bottom d-inline-block">{{ 'user-self-service.tax.change-joint-fsa.hint-confirm-change' | transloco }}</p>
            <p
              class="mb-1"
              [innerHTML]="
                'user-self-service.tax.change-joint-fsa.confirm.amount'
                  | transloco: { amount: editData[ATTR_NEW_FSA_AMOUT] | currency: 'EUR' : 'symbol' }
              "
            ></p>
            <p
              class="mb-1"
              [innerHTML]="
                'user-self-service.tax.change-joint-fsa.confirm.valid-from-to'
                  | transloco
                    : {
                        fromDate: editData[ATTR_NEW_FSA_VALIDFROM],
                        toDate: !checkValidTo ? '31.12.' + editData[ATTR_NEW_FSA_VALIDTO] : 'auf weiteres',
                      }
              "
            ></p>
          </div>
        </div>
      }
      @if (dialogMode === 'verify') {
        <div class="row mt-3">
          <div class="col-12 d-flex">
            <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
          </div>
        </div>
      }
    </div>
  }
</div>
